var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaxReceipt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "tax-receipt_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#tax-receipt_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 36.667c-1.273 0-2.355-.446-3.247-1.337-.89-.891-1.336-1.974-1.336-3.247v-5.138h5.194V3.333l2.494 2.5 2.495-2.5 2.495 2.5 2.494-2.5 2.494 2.5 2.5-2.5 2.5 2.5 2.5-2.5 2.5 2.5 2.5-2.5v28.75c0 1.273-.445 2.356-1.336 3.247-.892.891-1.974 1.337-3.247 1.337h-21Zm21-2.778c.528 0 .96-.17 1.299-.507.337-.338.506-.77.506-1.299V7.778H12.89v19.167h15.806v5.138c0 .528.168.961.506 1.3.338.337.771.506 1.299.506Zm-21.028 0h16.445v-4.167H7.695v2.361c0 .528.17.961.51 1.3.341.337.763.506 1.267.506Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.049 23.118c-.43.44-.952.66-1.563.66-.61 0-1.136-.22-1.576-.66-.44-.44-.66-.96-.66-1.563 0-.617.22-1.142.66-1.574.44-.432.96-.648 1.563-.648.617 0 1.142.216 1.574.646.432.43.648.951.648 1.563 0 .61-.216 1.136-.646 1.576ZM28.5 13.139 18.056 23.583 16.11 21.64l10.445-10.445L28.5 13.14ZM19.715 14.785c-.43.44-.951.66-1.562.66-.611 0-1.137-.22-1.576-.66-.44-.44-.66-.961-.66-1.563 0-.617.22-1.142.66-1.574.44-.432.96-.648 1.562-.648.617 0 1.142.215 1.574.646.432.43.648.951.648 1.562 0 .611-.215 1.137-.646 1.577Z"
}))));
export default SvgTaxReceipt;